import {
    CONFIRMED_GET_PRICE_UNIT
} from '../actions/PriceUnit/PriceUnitTypes';
const initialState = {
    priceUnit: [],
    loading: false,
};

function PriceUnitReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'PRICE_UNIT_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_PRICE_UNIT:
            return {
                ...state,
                priceUnit: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {PriceUnitReducer};